import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { StatusMapper } from '../mappers';
import { IStatusLog } from '../interfaces';

export type IGetStatusHistoryRepoResponse = IRepoResponse<200, IStatusLog[]> | IRepoResponse<400 | 500, string>;

export type IGetStatusHistoryRepoInput = { modelId: string | number; objectId: string | number };

export type IGetStatusHistoryRepo = IRepo<[IGetStatusHistoryRepoInput], IGetStatusHistoryRepoResponse>;

export const GetStatusHistoryRepoType = Symbol.for('GetStatusHistoryRepo');

@bind(GetStatusHistoryRepoType)
export class GetStatusHistoryRepo implements IGetStatusHistoryRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ modelId, objectId }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/states/history', { model_id: modelId, objectId }) });

      if (result.status === 200) {
        const data: IStatusLog[] = result.data.data.map((item) => StatusMapper.toDomain(item));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
